module.exports = __webpack_public_path__ + "front/img/poster1.13c3d09f.jpg";